import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import 'typeface-source-sans-pro'
import '../assets/font-awesome-5/css/fontawesome-all.css'
import './styles.sass'

const TemplateWrapper = ({ children }) => (
  <Fragment>
    <Helmet>
      <title>Fiel Code</title>
      <meta name='description' content='' />
    </Helmet>
    <Fragment>{children()}</Fragment>
  </Fragment>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js